/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import AuthenticationUsernameForm from 'src/shared/app/authentication/component/base/AuthenticationUsernameForm';
import logInMessages from 'src/shared/app/authentication/l10n/logInL10n';

type Props = {
  eventName: string,
  username: ?string,
  type: ?string,
  legend: ?string,
  label: ?string,
  placeholder: ?string,
  note: ?string,
  isLegendHidden: boolean,
  handleSubmit: (Object) => Promise<any>,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const LoginUsernameFormDumb = ({
  eventName,
  username,
  type,
  legend,
  label,
  placeholder,
  note,
  isLegendHidden,
  handleSubmit,
  intl,
}: Props): React.Node => (
  <AuthenticationUsernameForm
    type={type}
    initialUsername={username}
    legend={
      isLegendHidden
        ? ''
        : legend ||
          intl.formatMessage(logInMessages.usernameLegend, { eventName })
    }
    label={label}
    placeholder={placeholder}
    note={note}
    submitCta={intl.formatMessage(logInMessages.usernameSubmit)}
    handleSubmit={handleSubmit}
  />
);

export default compose(React.memo, injectIntl)(LoginUsernameFormDumb);
